export function adminDepositPayDialogTabularColumn() {
  return [
    {
      name: 'title',
      title: 'عنوان'
    },
    {
      name: 'payable_type',
      title: 'نوع واریزی'
    },
    {
      name: 'created_at',
      title: 'تاریخ ایجاد'
    },
    {
      name: 'account_type',
      title: 'نوع حساب'
    },
    {
      name: 'account_owner_name',
      title: 'نام صاحب حساب'
    }
  ]
}